import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  GlueCatalogID,
  GlueColumnNames,
  GlueColumnTypes,
  GlueCompactionEnabled,
  GlueCompactionFilesCompacted,
  GlueCompactionLastRunStatus,
  GlueCompactionStrategy,
  GlueDatabaseName,
  GlueIcebergFormatVersion,
  GlueIcebergTableLocation,
  GlueIcebergTableUUID,
  GlueOrphanFileDeletionEnabled,
  GlueOrphanFileDeletionLastRunStatus,
  GlueOrphanFileRetentionPeriod,
  GlueOrphanFilesDeleted,
  GluePartitionLastAnalyzedTime,
  GluePartitionStorageLocation,
  GluePartitionValues,
  GlueRetentionDataFilesDeleted,
  GlueRetentionEnabled,
  GlueRetentionLastRunStatus,
  GlueRetentionPeriod,
  GlueTableCompressed,
  GlueTableInputFormat,
  GlueTableLastAccessedAt,
  GlueTableMaterializedView,
  GlueTableMultiDialectView,
  GlueTableOutputFormat,
  GlueTableParameters,
  GlueTableRegisteredWithLakeFormation,
  GlueTableStorageLocation,
  GlueTableType,
  GlueTableUpdatedAt,
  GlueTableVersionIDs,
  GlueTableVersionUpdatedAt,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSGlueTableMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        name={metadata}
        createdAt={metadata}
        vpc="None"
        state="None"
        availabilityZone="None"
        owner="None"
      />
      {GlueTableUpdatedAt(metadata)}
      {GlueTableLastAccessedAt(metadata)}
      {GlueTableType(metadata)}
      {GlueTableParameters(metadata)}
      {GlueTableRegisteredWithLakeFormation(metadata)}
      {GlueTableMultiDialectView(metadata)}
      {GlueTableMaterializedView(metadata)}
      {GlueTableStorageLocation(metadata)}
      {GlueTableInputFormat(metadata)}
      {GlueTableOutputFormat(metadata)}
      {GlueTableCompressed(metadata)}
      {GlueIcebergTableLocation(metadata)}
      {GlueIcebergTableUUID(metadata)}
      {GlueIcebergFormatVersion(metadata)}
      {GlueCompactionEnabled(metadata)}
      {GlueCompactionStrategy(metadata)}
      {GlueCompactionLastRunStatus(metadata)}
      {GlueCompactionFilesCompacted(metadata)}
      {GlueRetentionEnabled(metadata)}
      {GlueRetentionPeriod(metadata)}
      {GlueRetentionLastRunStatus(metadata)}
      {GlueRetentionDataFilesDeleted(metadata)}
      {GlueOrphanFileDeletionEnabled(metadata)}
      {GlueOrphanFileRetentionPeriod(metadata)}
      {GlueOrphanFileDeletionLastRunStatus(metadata)}
      {GlueOrphanFilesDeleted(metadata)}
      {GluePartitionValues(metadata)}
      {GluePartitionStorageLocation(metadata)}
      {GluePartitionLastAnalyzedTime(metadata)}
      {GlueColumnNames(metadata)}
      {GlueColumnTypes(metadata)}
      {GlueTableVersionIDs(metadata)}
      {GlueTableVersionUpdatedAt(metadata)}
      {GlueDatabaseName(metadata)}
      {GlueCatalogID(metadata)}
    </Grid>
  );
};
